import AudioFile from './audio-file';
class Sample extends AudioFile {
    constructor(sampleInfo) {
        super(sampleInfo.url);
        this.info = sampleInfo;
        this.init();
    }
}
export default Sample;
export { Sample, };
